import script from "./ReviewOrganizationTemplate.vue?vue&type=script&lang=js"
export * from "./ReviewOrganizationTemplate.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__